import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useState } from 'react';
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { FormStateChangeNotifier } from '../../UIKit1/form';
import { useIsInForm } from '../utils/useIsInForm';
import { Label } from '../label';
import { FieldContainer } from '../utils/FieldContainer';
var AKRange = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.range' */
  '@atlaskit/range');
});
var AKField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
export var Range = function Range(props) {
  var _ref = props.forgeDoc.props,
    defaultValue = _ref.defaultValue,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    label = _ref.label,
    name = _ref.name,
    testId = _ref.testId,
    _onChange = _ref.onChange;
  var initialValue = min >= (defaultValue || min) ? min : defaultValue;
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    rangeValue = _useState2[0],
    setRangeValue = _useState2[1];
  var isInForm = useIsInForm();
  if (!isInForm) {
    return /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Label, {
      name: name,
      label: label
    }), /*#__PURE__*/React.createElement(AKRange, {
      min: min,
      max: max,
      step: step,
      testId: testId,
      value: rangeValue,
      onChange: function onChange(v) {
        setRangeValue(v);
        _onChange === null || _onChange === void 0 || _onChange(v);
      }
    }));
  }
  return /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(AKField, {
    name: name,
    label: label,
    defaultValue: initialValue
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    var fieldOnChange = fieldProps.onChange,
      id = fieldProps.id,
      isDisabled = fieldProps.isDisabled,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      value = fieldProps.value,
      ariaInvalid = fieldProps['aria-invalid'],
      ariaLabelledBy = fieldProps['aria-labelledby'];
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FormStateChangeNotifier, {
      name: name,
      value: fieldProps.value
    }), /*#__PURE__*/React.createElement(AKRange, {
      id: id,
      min: min,
      max: max,
      step: step,
      testId: testId,
      onChange: function onChange(value) {
        fieldOnChange(value);
        _onChange === null || _onChange === void 0 || _onChange(value);
      },
      isDisabled: isDisabled,
      onBlur: onBlur,
      onFocus: onFocus,
      value: value,
      "aria-invalid": ariaInvalid,
      "aria-labelledby": ariaLabelledBy
    }));
  }));
};